import { Button, Form, Popover } from 'antd';
import { useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  FAIcon,
  FATypes,
} from '../../../../components/adapters/fontAwesomeAdapters';
import { FLIGHTS_QUERY } from '../../../../app/graphql/jobQueries';
import SearchFlightsPopoverContent from './SearchFlightsPopoverContent';
import { useFormContext } from '../../../../components/forms/forms';
import { useNewShipmentFlightInformationFormStyles } from '../../newShipment/NewShipmentFlightInformationForm.styles';

function SearchFlightsButton({ onChange, disabled }) {
  const { styles } = useNewShipmentFlightInformationFormStyles();
  const { formInstance } = useFormContext();
  const [open, setOpen] = useState(false);
  const [fetchFlights, { loading = false, data }] = useLazyQuery(FLIGHTS_QUERY);

  const onFlightSelect = () => {
    const allFields = formInstance.getFieldsValue();
    const fieldNames = Object.keys(allFields);
    const fieldsToValidate = fieldNames.filter(name => name !== 'flight');
    formInstance
      .validateFields(fieldsToValidate)
      .then(
        ({
          flightAirline,
          routeAirline,
          routeDepartureAirport,
          routeArrivalAirport,
          flightDeparture,
          routeDeparture,
          flightNumber,
        }) => {
          setOpen(true);
          fetchFlights({
            variables: {
              input: {
                airline: flightAirline?.code || routeAirline?.code || '',
                originAirport: routeDepartureAirport?.code || '',
                destinationAirport: routeArrivalAirport?.code || '',
                departureDate: flightDeparture || routeDeparture || '',
                flightNumber,
              },
            },
          });
        }
      );
  };

  return (
    <Popover
      content={
        <SearchFlightsPopoverContent
          flights={data?.getFlights || []}
          isLoading={loading}
          onClick={flight => {
            onChange(flight);
            setOpen(false);
          }}
        />
      }
      classNames={{ root: styles.flightsPopoverOverlay }}
      placement="bottomRight"
      showArrow={false}
      trigger="click"
      open={open}
      onOpenChange={newOpen => {
        setOpen(newOpen);
      }}
    >
      <Button
        size="small"
        data-subject="flight-search"
        data-action="search"
        id="flight-search"
        disabled={disabled}
        onClick={onFlightSelect}
      >
        <FAIcon icon="search" className="icon-15" type={FATypes.SOLID} />
        <FormattedMessage id="book.newAirRetrieval.search" />
      </Button>
    </Popover>
  );
}

export default function SearchFlightFormItem({ disabled }) {
  const { formatMessage: f } = useIntl();
  const { styles } = useNewShipmentFlightInformationFormStyles();

  return (
    <Form.Item
      name="flight"
      className={styles.addFlightButton}
      rules={[
        {
          required: true,
          message: f({ id: 'book.newAirRetrieval.error.searchFlight' }),
        },
      ]}
    >
      <SearchFlightsButton disabled={disabled} />
    </Form.Item>
  );
}
